export enum RequestType {
  TryItNow = 'TRY_IT_NOW'
}
